module.exports = __webpack_public_path__ + "img/ImageHover3.7b42ff20.png";